import React, { useRef, useState } from "react";
import Form from "react-bootstrap/Form";

const Search = ({ onChange, defaultValue }) => {

    const timer = useRef(null);

    const [value, setValue] = useState(defaultValue || '');

    // Throttle the onChange callback so it doesn't trigger immediately
    const handleInput = val => {

        setValue(val);

        if (timer.current)
            clearTimeout(timer.current);

        if (onChange)
            timer.current = setTimeout(() => {
                onChange(val);
            }, 1000);

    };

    return (
        <Form.Control
            type="input"
            value={value}
            onChange={e => handleInput(e.target.value)}
            placeholder="Search..."
            />
    );

};

export default Search;
